import { getFirestore } from '../../system/firebase';

import {
    SNACK_BAR_MESSAGE_OPERATION_FAILED,
    SNACK_BAR_MESSAGE_SAVE,
    SNACK_BAR_MESSAGE_CONFIRM,
    SNACK_BAR_MESSAGE_SEND,
    SNACK_BAR_MESSAGE_DECLINE,
    INTERVIEW_STATUS_CONFIRMED,
    INTERVIEW_STATUS_RESCHEDULE_JS,
    INTERVIEW_STATUS_DECLINED,
} from '../constants';
import { convertFirebaseTimestampsToDate } from '../dateHelper';

import { startOfMonth, endOfMonth, getMonth, startOfDay, isEqual as isEqualDate /*, format as formatDate*/ } from 'date-fns';

import _get from 'lodash/get';
// import _set from 'lodash/set';
import _fpSet from 'lodash/fp/set';
import _map from 'lodash/map';
import _forEach from 'lodash/forEach';
import _findKey from 'lodash/findKey';
import _isEmpty from 'lodash/isEmpty';

export const loadInterviewCard = (interviewId, setInterviewData, setInterviewCardOpen) => {
    const db = getFirestore();

    const interviewRef = db.collection('interviews').doc(interviewId);

    return interviewRef.onSnapshot(doc => {
        if (doc.exists) {
            let data = doc.data();

            // map Google Timestamp to javascript Date
            data = convertFirebaseTimestampsToDate(data, ['startDt', 'endDt', 'previousStartDt', 'previousEndDt']);

            console.log('myCalendarServices loadInterviewCard data', data);
            setInterviewData({ interviewId, ...data });
            setInterviewCardOpen(true);
        }
    });
};

export const saveNote = (interviewId, setIsNoteEnabled, setSnackbarMessage, setSnackbarErrorMessage, note = '') => {
    const db = getFirestore();
    const now = new Date();

    const interviewRef = db.collection('interviews').doc(interviewId);

    return db
        .runTransaction(transaction => {
            // This code may get re-run multiple times if there are conflicts.
            return transaction.get(interviewRef).then(function (doc) {
                if (!doc.exists) {
                    throw new Error('Document does not exist!');
                }

                transaction.update(interviewRef, { note, updateDt: now });
            });
        })
        .then(function () {
            // console.log('Transaction successfully committed!');
            setSnackbarMessage(SNACK_BAR_MESSAGE_SAVE);
            setIsNoteEnabled(false);
        })
        .catch(function (error) {
            console.error('Save note transaction failed: ', error);
            setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        });
};

export const confirmInterview = (interviewId, setInterviewCardOpen, setSnackbarMessage, setSnackbarErrorMessage, detachInterviewCardListener) => {
    const db = getFirestore();
    const now = new Date();

    const interviewRef = db.collection('interviews').doc(interviewId);

    return db
        .runTransaction(transaction => {
            // This code may get re-run multiple times if there are conflicts.
            return transaction.get(interviewRef).then(function (doc) {
                if (!doc.exists) {
                    throw new Error('Document does not exist!');
                }

                transaction.update(interviewRef, { status: INTERVIEW_STATUS_CONFIRMED, statusUpdatedByEmp: false, updateDt: now });
            });
        })
        .then(function () {
            // console.log('Transaction successfully committed!');
            setSnackbarMessage(SNACK_BAR_MESSAGE_CONFIRM);
            detachInterviewCardListener();
            setInterviewCardOpen(false);
        })
        .catch(function (error) {
            console.error('Confirm interview transaction failed: ', error);
            setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        });
};

export const declineInterview = ({ interviewId, setIsDeclineEnabled, declineReason, setSnackbarMessage, setSnackbarErrorMessage }) => {
    const db = getFirestore();
    const now = new Date();

    const interviewRef = db.collection('interviews').doc(interviewId);

    return db
        .runTransaction(transaction => {
            // This code may get re-run multiple times if there are conflicts.
            return transaction.get(interviewRef).then(function (doc) {
                if (!doc.exists) {
                    throw new Error('Document does not exist!');
                }

                transaction.update(interviewRef, { status: INTERVIEW_STATUS_DECLINED, declineReason: declineReason, statusUpdatedByEmp: false, updateDt: now });
            });
        })
        .then(function () {
            // console.log('Transaction successfully committed!');
            setSnackbarMessage(SNACK_BAR_MESSAGE_DECLINE);
            setIsDeclineEnabled(false);
        })
        .catch(function (error) {
            console.error('Decline interview transaction failed: ', error);
            setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        });
};

export const loadCurrentMonthInterviewsByUserId = (userId, calendarData = {}, setInterviewList) => {
    const db = getFirestore();

    const currentMonthIdx = getMonth(_get(calendarData, 'w1d0.dt'));
    const firstDayOf6thWeek = _get(calendarData, 'w5d0.dt');
    const has6Weeks = currentMonthIdx === getMonth(firstDayOf6thWeek);
    const endDtPath = has6Weeks ? 'w5d6.dt' : 'w4d6.dt';

    const startDt = _get(calendarData, 'w0d0.dt', startOfMonth(new Date()));
    const endDt = _get(calendarData, endDtPath, endOfMonth(new Date()));

    const interviewsRef = db.collection('interviews').where('jobSeekerId', '==', userId).where('startDt', '>=', startDt).where('startDt', '<=', endDt);

    return interviewsRef.onSnapshot(querySnapshot => {
        const interviewList = _map(querySnapshot.docs, doc => {
            const data = doc.data();
            const startDt = _get(data, 'startDt');
            const startDtStartOfDay = startDt ? startOfDay(startDt.toDate()) : null;
            const dayId = _findKey(calendarData, item => isEqualDate(_get(item, 'dt'), startDtStartOfDay));
            return { interviewId: doc.id, dayId, ...data };
        });

        setInterviewList(interviewList);
    });
};

export const loadCurrentWeekInterviewsByUserId = (userId, startDt, endDt, setInterviewList) => {
    const db = getFirestore();

    const interviewsRef = db.collection('interviews').where('jobSeekerId', '==', userId).where('startDt', '>=', startDt).where('startDt', '<=', endDt);

    return interviewsRef.onSnapshot(querySnapshot => {
        let interviewList = [];

        _forEach(querySnapshot.docs, doc => {
            const data = doc.data();

            if (!_isEmpty(data.startDt) && !_isEmpty(data.endDt)) {
                interviewList.push({ interviewId: doc.id, ...data });
            }
        });

        console.log('@@@@ loadCurrentWeekInterviewsByUserId interviewList=', interviewList);

        setInterviewList(interviewList);
    });
};

export const saveRescheduleInterviewRequest = ({
    interviewId,
    startDt,
    endDt,
    proposedStartDt,
    proposedEndDt,
    setIsRescheduleEnabled,
    setSnackbarMessage,
    setSnackbarErrorMessage,
}) => {
    const db = getFirestore();
    const now = new Date();

    const interviewRef = db.collection('interviews').doc(interviewId);

    return db
        .runTransaction(transaction => {
            // This code may get re-run multiple times if there are conflicts.
            return transaction.get(interviewRef).then(function (doc) {
                if (!doc.exists) {
                    throw new Error('Document does not exist!');
                }

                transaction.update(interviewRef, {
                    status: INTERVIEW_STATUS_RESCHEDULE_JS,
                    startDt: proposedStartDt,
                    endDt: proposedEndDt,
                    previousStartDt: startDt,
                    previousEndDt: endDt,
                    statusUpdatedByEmp: false,
                    updateDt: now,
                });
            });
        })
        .then(function () {
            // console.log('Transaction successfully committed!');
            setSnackbarMessage(SNACK_BAR_MESSAGE_SEND);
            setIsRescheduleEnabled(false);
            // setInterviewData({ ...interviewData, note });
        })
        .catch(function (error) {
            console.error('Request reschedule interview transaction failed: ', error);
            setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        });
};

export const loadProfileByUserId = (userId, setProfileData) => {
    const db = getFirestore();

    const profileRef = db.collection('profiles').doc(userId);

    return profileRef.onSnapshot(docSnapshot => {
        let data = docSnapshot.data();

        data = convertFirebaseTimestampsToDate(data, ['createDt', 'updateDt']);
        const resumeList = _get(data, 'resumeList');
        const resumeListMappedDates = _map(resumeList, resume => {
            return convertFirebaseTimestampsToDate(resume, ['updateDt']);
        });
        data = _fpSet('resumeList', resumeListMappedDates, data);

        setProfileData({ ...data });
    });
};
